import { __awaiter } from "tslib";
import axios from 'axios';
import { key, useAuthenticate } from '@/logics/auth';
import { store } from '@/store/store';
const ApiBaseRepository = axios.create({
    baseURL: process.env.VUE_APP_FOCREX_API_URL || 'http://localhost:8080',
    responseType: 'json',
    timeout: process.env.VUE_APP_RESPONSE_TIMEOUT || 30000,
    validateStatus: (status) => 200 <= status && status < 300,
});
// request
const interceptSetUp = (config) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const { getToken } = useAuthenticate();
    config.headers['Authorization'] = `Bearer ${getToken()}`;
    !!((_a = store.state.userSettings) === null || _a === void 0 ? void 0 : _a.language) && (config.headers['App-Language'] = (_b = store.state.userSettings) === null || _b === void 0 ? void 0 : _b.language);
    return config;
});
ApiBaseRepository.interceptors.request.use(interceptSetUp);
// response
let isRetry = false;
export const interceptSuccess = (response) => __awaiter(void 0, void 0, void 0, function* () {
    return response;
});
export const interceptError = (error) => __awaiter(void 0, void 0, void 0, function* () {
    const { onLogout } = useAuthenticate();
    const url = error.config.url;
    if (url === '/health') {
        return Promise.reject(error);
    }
    if (error.response.status === 503) {
        yield onLogout(false);
        return Promise.reject(error);
    }
    if (url === '/auth/me') {
        return Promise.resolve();
    }
    if ('/auth/login' !== url && '/auth/connect' !== url && error.response.status === 401 && !isRetry) {
        // トークンの有効期限が切れていた場合は一度
        isRetry = true;
        const res = yield ApiBaseRepository.post('/auth/refresh', {});
        if (res.status === 200) {
            localStorage.setItem(key, res.data.access_token);
            isRetry = false;
            return ApiBaseRepository.request(error.config);
        }
        else {
            localStorage.removeItem(key);
            console.log('refresh error');
            return Promise.reject();
        }
    }
    // 認証以外のエラーで失敗した場合など
    return Promise.reject(error);
});
ApiBaseRepository.interceptors.response.use(interceptSuccess, interceptError);
export default ApiBaseRepository;
